/**
 * Shared loading panel — presentation only.
 *
 * Consumers (S1): Dashboard, Devices, Analysis, DataLoggerDetail
 *
 * Contract:
 * - `message` is caller-owned copy (translated or hardcoded).
 * - `variant="fill"` preserves historical full-area spinner markup.
 * - `variant="box"` preserves h-64 centered block used on detail pages.
 * - `className` / `messageClassName` extend without replacing defaults unless overridden via className on the root for non-default layouts.
 * - No data fetching, auth, or i18n inside this component.
 */
export function LoadingState({
  message = 'Duke ngarkuar...',
  variant = 'fill',
  className,
  messageClassName,
  asMessage: MessageTag = 'p',
}) {
  if (variant === 'box') {
    return (
      <div className={className || 'flex items-center justify-center h-64'}>
        <div className={messageClassName || 'text-ops-ink3'}>{message}</div>
      </div>
    );
  }

  // variant === 'fill' (default)
  return (
    <div className={className || 'flex items-center justify-center h-full'}>
      <MessageTag className={messageClassName || 'text-ops-ink3'}>{message}</MessageTag>
    </div>
  );
}
